import React, { useState } from 'react';
import PropTypes from 'prop-types';

function SelectionButton({ label, value, selected, onClick }) {
    return (
        <button
            onClick={() => onClick(value)}
            className={`flex-1 py-2 px-4 rounded-xl border-2 font-semibold text-sm transition-colors ${
                selected
                    ? 'border-[#28A48B] bg-[#e6f7f4] text-[#28A48B]'
                    : 'border-gray-300 text-gray-700 hover:border-[#28A48B]'
            }`}
        >
            <div>{label}</div>
            <div className="text-xs font-normal text-gray-500 mt-0.5 truncate">{value}</div>
        </button>
    );
}

SelectionButton.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

const parsePhones = (str) => str.split(',').map((p) => p.trim()).filter(Boolean);

const togglePhone = (current, value) => {
    const list = parsePhones(current);
    if (list.includes(value)) {
        return list.filter((p) => p !== value).join(', ');
    }
    return [...list, value].join(', ');
};

function AddressSlipSelectorModal({ userName, userPhone, patientName, patientPhone, onConfirm, onClose }) {
    const [name, setName] = useState(userName || '');
    const [phone, setPhone] = useState(userPhone || '');

    const namesAreSame = userName && patientName && userName.toLowerCase() === patientName.toLowerCase();
    const phonesAreSame = userPhone && patientPhone && userPhone === patientPhone;

    const selectedPhones = parsePhones(phone);

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
            onClick={onClose}
        >
            <div
                className="bg-white-50 rounded-2xl shadow-xl p-8 w-full max-w-lg flex flex-col gap-6"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-xl font-bold text-gray-800">Address Slip — Select Name & Phone</h2>

                <div className="flex flex-col gap-2">
                    <p className="text-sm text-gray-500 font-medium">Name</p>
                    <div className="flex gap-3">
                        {userName && (
                            <SelectionButton
                                label="User"
                                value={userName}
                                selected={name === userName}
                                onClick={setName}
                            />
                        )}
                        {patientName && !namesAreSame && (
                            <SelectionButton
                                label="Patient"
                                value={patientName}
                                selected={name === patientName}
                                onClick={setName}
                            />
                        )}
                    </div>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="border border-gray-300 rounded-xl px-4 py-2 text-gray-800 focus:outline-none focus:border-[#28A48B]"
                        placeholder="Or enter manually..."
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <p className="text-sm text-gray-500 font-medium">Phone</p>
                    <div className="flex gap-3">
                        {userPhone && (
                            <SelectionButton
                                label="User"
                                value={userPhone}
                                selected={selectedPhones.includes(userPhone)}
                                onClick={(val) => setPhone((prev) => togglePhone(prev, val))}
                            />
                        )}
                        {patientPhone && !phonesAreSame && (
                            <SelectionButton
                                label="Patient"
                                value={patientPhone}
                                selected={selectedPhones.includes(patientPhone)}
                                onClick={(val) => setPhone((prev) => togglePhone(prev, val))}
                            />
                        )}
                    </div>
                    <input
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="border border-gray-300 rounded-xl px-4 py-2 text-gray-800 focus:outline-none focus:border-[#28A48B]"
                        placeholder="Or enter manually..."
                    />
                </div>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 rounded-xl border border-gray-300 text-gray-600 font-semibold hover:bg-white-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm({ name: name.trim(), phone: phone.trim() })}
                        disabled={!name.trim() && !phone.trim()}
                        className="px-6 py-2 rounded-xl bg-[#28A48B] text-white font-semibold hover:bg-[#1f8c76] disabled:opacity-50"
                    >
                        Print
                    </button>
                </div>
            </div>
        </div>
    );
}

AddressSlipSelectorModal.propTypes = {
    userName: PropTypes.string,
    userPhone: PropTypes.string,
    patientName: PropTypes.string,
    patientPhone: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AddressSlipSelectorModal;
